export const SET_OPTIONS = 'SET_OPTIONS';
export const SET_PACKAGES = 'SET_PACKAGES';
export const SET_SHOW_PRICING = 'SET_SHOW_PRICING';



// WEBPACK FOOTER //
// ./src/actions/types.js